import React from "react";
import { Link } from "react-router-dom";
import { getConfigData } from "../../../services/Helper";

function SectionTitle({ subtitle, title, viewAllLink }) {
      const configData = getConfigData();
      const server = configData.server;
  return (
    <>
      <div className="clr height30" />
      {!!subtitle && <div className="smallertex"> {subtitle}</div>}
      {!!title && <h2 className="heading-style list-inline-item">{title}</h2>}
      {!!viewAllLink &&
        <Link to={server.base_url + "/diagnostic-test"} className="btn btn-viewall-right float-end">
          View All <i className="icon-thin-right"></i>
        </Link>
      }
      <div className="clr height20" />
    </>
  );
}

export default SectionTitle;
